<template>
  <div>
    <v-dialog v-model="trayDialog" max-width="600px" contentClass="rounded-lg">
      <v-card class="px-6 py-4">
        <h4>Gerenciamento de Impressão</h4>
        <templete v-if="!isActive">
          <v-alert color="info" text>
            O sistema utiliza o QZ Tray para gerenciar a impressão de ingressos
            e recibos. Certifique-se de que o QZ Tray esteja instalado e em
            execução no computador.
            <v-btn
              text
              href="https://qz.io/download/"
              target="_blank"
              rel="noopener"
            >
              Baixar QZ Tray
            </v-btn>
            <v-btn text @click="launchQZ" target="_blank" rel="noopener">
              Abrir QZ Tray
            </v-btn>
          </v-alert>
          <v-btn text @click="connect"> Connectar </v-btn>
        </templete>
        <template v-else>
          <v-alert color="success" text>
            Conectado ao QZ Tray com sucesso!
          </v-alert>
          <v-alert
            @click="$emit('certificateInstallInstructions')"
            type="info"
            icon="mdi-certificate"
            text
          >
            <div class="d-flex justify-space-between align-center">
              Instale o certificado de segurança para conseguir imprimir sem
              precisar aprovar todas as vezes.
              <v-btn
                color="primary"
                depressed
                @click="$emit('certificateInstallInstructions')"
              >
                Instalar
              </v-btn>
            </div>
          </v-alert>

          <QZSettings :qz="qz" />
        </template>
        <div class="d-flex mt-4 justify-center">
          <v-btn text @click="trayDialog = false">Fechar</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <q-z-certificate-install :qz="qz" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import * as qz from "qz-tray";
import manageCertificates from "@/utils/qz-tray/manageCertificates";
import QZCertificateInstall from "./QZCertificateInstall.vue";
import QZSettings from "./QZSettings.vue";

export default {
  name: "QZTrayManagement",
  components: {
    QZCertificateInstall,
    QZSettings,
  },
  data() {
    return {
      trayDialog: true,
      printerList: [],
      error: null,
      sequential: 0,
      qz,
    };
  },
  methods: {
    ...mapActions("qz", ["setConnectionStatus", "selectPrinter"]),
    open() {
      this.sequential = 0;
      this.trayDialog = true;
      if (!this.isActive) this.connect();
    },
    async manageCertificates() {
      try {
        await manageCertificates(qz);
      } catch (error) {
        console.error("Error managing QZ Tray certificates:", error);
      }
    },
    async connect() {
      this.error = null;
      try {
        if (this.isActive) {
          console.log("QZ Tray already connected");
          return;
        }
        await qz.websocket.connect();
        this.sequential++;
        this.setDisconectionListener();
      } catch (error) {
        this.error = error.message || error;
        console.error("Error connecting to QZ Tray:", error);
      }
    },
    async print({ type, format, data, flavor }) {
      if (!this.isActive) {
        console.warn("QZ Tray is not connected");
        return;
      }

      const config = this.qz.configs.create(this.selectedPrinter, {
        units: "mm",
        size: { width: parseInt(this.settings.paperSize.replace(/\D/g, "")) },
      });
      const payload = [{ type, format, data, flavor }];
      // if (this.settings.cutting) {
      //   payload.push({
      //     type: "raw",
      //     format: "command",
      //     data: this.settings.cuttingPattern,
      //   });
      // }
      await this.qz.print(config, payload);
      if (this.settings.cutting) {
        await this.qz.print(config, [
          "\x1B\x40", // Initialize printer
          this.settings.cuttingPattern,
        ]);
      }
      this.$root.$emit("print:done");
    },
    setDisconectionListener() {
      qz.websocket.setClosedCallbacks(() => {
        console.warn("QZ Tray connection closed");
        this.sequential++;
      });
      qz.websocket.setErrorCallbacks((err) => {
        console.error("QZ Tray connection error:", err);
        this.sequential++;
      });
    },

    launchQZ() {
      window.location.assign("qz:launch");
    },
  },
  computed: {
    ...mapGetters("qz", ["selectedPrinter", "settings"]),
    isActive() {
      this.sequential;
      const active = this.qz.websocket.isActive();
      this.setConnectionStatus(active);
      return active;
    },
  },
  mounted() {
    this.manageCertificates().then(() => {
      this.connect();
    });
    this.$root.$on("qz-tray-config", this.open);
    this.$root.$on("print", this.print);
  },
  beforeDestroy() {
    this.$root.$off("qz-tray-config");
    this.$root.$off("print", this.print);
  },
};
</script>
